import { useLocale, useSetLocale, useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";

// Persistence is handled centrally by i18nProvider.changeLocale.
export const LocaleToggle = () => {
  const locale = useLocale();
  const translate = useTranslate();
  const setLocale = useSetLocale();
  return (
    <div
      className="flex gap-1"
      role="group"
      aria-label={translate("gavion.common.language")}
    >
      {(["fr", "en"] as const).map((l) => (
        <Button
          key={l}
          type="button"
          size="sm"
          variant={locale === l ? "secondary" : "ghost"}
          aria-pressed={locale === l}
          onClick={() => setLocale(l)}
        >
          {l.toUpperCase()}
        </Button>
      ))}
    </div>
  );
};
